module.exports = __webpack_public_path__ + "static/media/line.55b4b384.svg";